var React = require('react/addons');
var cx = require('classnames');

module.exports = React.createClass({
  render: function() {
    var field = this.props.field;
    var model = this.props.model;
    var adminOnly = this.props.adminOnly;
    var placeholder = this.props.placeholder;
    var error = this.props.error;

    var classes = cx({
      "field": true,
      "ofs-Form__Field": true,
      "error": error ? true : false, 
      "admin-only": adminOnly,
    });

    return (
      <div className={classes}>
        {this.props.label ? <label className="ofs-Form__Label" htmlFor={this.props.name}>{this.props.label}</label> : null}
        <div className="widget">
        {this.props.children}
        {error ? <p className="ofs-Input__ErrorMessage">{error}</p> : null}
        </div>
      </div>
    );
  }
});



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/react/fields/field.jsx
 **/